// extracted by mini-css-extract-plugin
export default {"container":"DynamicBanner__container--3Wq","isActive":"DynamicBanner__isActive--zSJ"};